import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import adminOverViewTabRouter from "./adminOverviewTabRouter";

function AdminOverviewTab(props) {

  return (
    <TabTemplate 
      router={adminOverViewTabRouter}
      passData={props.passData}
    />
  )

}

export default AdminOverviewTab;